<template>
  <v-card>
    <v-card-title>
      <span class="headline">Add Donation Center Form</span>
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <v-text-field
              v-model="name"
              label="Name of the Donation Center"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="6" sm="12" md="6">
            <v-text-field
              v-model="phoneNumber"
              label="phone number"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="6" sm="12" md="6">
            <v-text-field
              v-model="address"
              label="Address"
              hint="More description about the location"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <v-autocomplete
              v-model="city"
              :items="cities"
              label="City"
              placeholder="Enter the City"
              append-icon="mdi-map-marker"
              auto-select-first
            ></v-autocomplete>
          </v-col>
          <v-col cols="6" sm="12" md="6">
            <v-text-field
              v-model="country"
              label="Country"
              required
            ></v-text-field>
          </v-col>
        </v-row>
      </v-container>
      <small>*indicates required field</small>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="this.triggerCloseDialog">
        Close
      </v-btn>
      <v-btn color="blue darken-1" text @click="this.saveDonationCenter">
        Save
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import { eventBus } from "@/main.js";
import { mapFields } from "vuex-map-fields";
import { mapActions } from "vuex";
import cities from "../shared/constants/cities";

// You can use this package but has a big file thus performance issue
//example -> import cityList from 'cities.json';

export default {
  async created() {
    this.populateFromCities();
  },
  components: {},
  computed: {
    ...mapFields("donation", ["allLocations"]),
  },
  data: () => ({
    name: "",
    address: "",
    city: "",
    cities: [],
    country: "",
    location: [],
    phoneNumber: "",
  }),
  methods: {
    ...mapActions("donation", ["addDonationCenter"]),
    triggerCloseDialog(value) {
      eventBus.$emit("dialogToggle", false);
    },
    populateFromCities() {
      cities.map((city) => {
        this.cities.push(city.name);
      });
    },
    async saveDonationCenter() {
      // store the accurate location of the city/country
      var location = cities.find((element) => element.name === this.city);

      // extract only latitude and longitudes
      this.location.push({ lat: location.lat, long: location.lng });

      var DonationCenter = {
        name: this.name,
        address: this.address,
        city: this.city,
        country: this.country,
        location: this.location,
        phoneNumber: this.phoneNumber,
      };

      try {
        this.addDonationCenter({
          payload: {
            center: DonationCenter,
          },
        });

        alert("Successfully added Donation Center!");
      } catch (error) {
        alert("Failed to add Donation Center!");
      } finally {
        eventBus.$emit("dialogToggle", false);
      }
    },
  },
};
</script>